module.exports = __webpack_public_path__ + "static/img/manual-33.369f3db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-33.png
// module id = +Uhb
// module chunks = 4